import { Box, Stack, Typography } from '@mui/material';
import { DimensionVideo } from '../models/DimensionVideoListModel';
import { secondsToMMSS } from '@xolv-mybrightlink/common';
import React from 'react';

interface DimensionVideoCardProps {
  video: DimensionVideo;
  onItemClicked: () => void;
}

const DimensionVideoCard = React.forwardRef<
  HTMLDivElement,
  DimensionVideoCardProps
>((props, ref) => {
  return (
    <Stack
      ref={ref}
      onClick={props.onItemClicked}
      sx={{
        cursor: 'pointer',
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: 0,
          pb: '56.48%',
          borderRadius: 3,
          position: 'relative',
          boxShadow: 8,
          backgroundSize: 'contain',
          backgroundImage: `url(${props.video.image})`,
        }}
      >
        <Box
          sx={{
            borderRadius: 1,
            backgroundColor: '#212733e6',
            height: 26,
            position: 'absolute',
            bottom: 11,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            right: 11,
          }}
        >
          <Typography
            sx={{
              px: 4.25,
              fontSize: 12,
              color: '#fff',
            }}
          >
            {secondsToMMSS(props.video.duration)}
          </Typography>
        </Box>
      </Box>
      <Typography
        variant='body1'
        fontWeight={'500'}
        sx={{
          mt: 5,
        }}
      >
        {`${props.video.wpPostOrder + 1}. ${props.video.title}`}
      </Typography>
    </Stack>
  );
});

DimensionVideoCard.displayName = 'DimensionVideoCard';

export default DimensionVideoCard;
